import { roundUpPrice } from '@/utils/circuits/prices/formatPrice';
import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import i18next from '@/i18n/config';

export type DistributorDataWithStats = {
  id: string;
  ref: number;
  name: string;
  network: {
    name: string;
    id: string;
  };
  createdAt: string;
  _count: {
    receivers: number;
    circuits: number;
  };
  reserved: number;
  inWait: number;
  received: number;
  pending: number;
  transformationRateInWait: number;
  transformationRateReceived: number;
  transformationRatePending: number;
};

const t = i18next.t;

export const ALL_DISTRIBUTORS_COLUMNS: ColumnDef<DistributorDataWithStats>[] = [
  {
    accessorKey: 'ref',
    header: t('pages.admin.distributors.columns.code'),
  },
  {
    accessorKey: 'name',
    header: t('pages.admin.distributors.columns.name'),
  },
  {
    accessorKey: 'network.name',
    header: t('pages.admin.distributors.columns.network'),
  },
  {
    accessorKey: 'createdAt',
    header: t('pages.admin.distributors.columns.createdAt'),
    cell: ({ row }) => (
      <span>{format(new Date(row.original.createdAt), 'dd/MM/yyyy')}</span>
    ),
  },
  {
    accessorKey: '_count.receivers',
    header: t('pages.admin.distributors.columns.receiversCount'),
  },
  {
    accessorKey: '_count.circuits',
    header: t('pages.admin.distributors.columns.circuitsCount'),
  },
  {
    accessorKey: 'reserved',
    header: t('pages.admin.distributors.columns.reservations'),
  },
  {
    accessorKey: 'inWait',
    header: t('pages.admin.distributors.columns.inWait'),
  },
  {
    accessorKey: 'received',
    header: t('pages.admin.distributors.columns.received'),
  },
  {
    accessorKey: 'pending',
    header: t('pages.admin.distributors.columns.pending'),
  },
  {
    accessorKey: 'transformationRateInWait',
    header: t('pages.admin.distributors.columns.transformationRateInWait'),
    cell: ({ row }) => (
      <span>{`${roundUpPrice(row.original.transformationRateInWait * 100)} %`}</span>
    ),
  },
  {
    accessorKey: 'transformationRateReceived',
    header: t('pages.admin.distributors.columns.transformationRateReceived'),
    cell: ({ row }) => (
      <span>{`${roundUpPrice(row.original.transformationRateReceived * 100)} %`}</span>
    ),
  },
  {
    accessorKey: 'transformationRatePending',
    header: t('pages.admin.distributors.columns.transformationRatePending'),
    cell: ({ row }) => (
      <span>{`${roundUpPrice(row.original.transformationRatePending * 100)} %`}</span>
    ),
  },
];
